<template>
  <div
    class="sidebar"
    :data-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <router-link to="/main" style="display: block">
      <div
        class="logo"
        :style="{ backgroundImage: 'url(' + franchise.logo + ')' }"
      ></div>
    </router-link>
    <!--      <a class="simple-text logo-mini"-->
    <!--         style="width: 100%; margin-left: auto;margin-right: auto"-->
    <!--         href="https://www.letsnova.ru">-->
    <!--          <div class="logo-img"-->
    <!--          style="width: auto">-->
    <!--              <img :src="logo" alt="" style="height: 34px;">-->
    <!--          </div>-->
    <!--      </a>-->

    <!-- <table class="balances">
        <tr>
          <td>
            <div class="balance" type="real">{{balance.real}}</div>/
            <div class="balance" type="bonus">{{balance.bonus}}</div>

            <div class="refresh_balances" @click="this.refresh_balances" ref="refresh_balances">
              <i class="far fa-sync"></i>
            </div>
          </td>
        </tr>
      </table>-->

    <!-- <div class="simple-text logo-normal mx-auto pl-3">actid</div> -->
    <div class="logout_button" title="Выход">
      <i class="fal fa-sign-out-alt" @click="$auth.logout(true)"></i>
    </div>

    <!--      <a class="simple-text logo-normal"-->
    <!--         href="https://www.letsnova.ru">-->
    <!--          actid-->
    <!--      </a>-->
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <!-- <slot>

      </slot>-->
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in this.sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
// import apiDriver from "../../Actid/apiDriver";
import { duration } from "moment";
export default {
  props: {
    title: {
      type: String,
      default: "Nova",
      description: "Sidebar title",
    },
    backgroundColor: {
      type: String,
      default: "white",
      validator: (value) => {
        let acceptedValues = ["white", "brown", "black"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: "Sidebar background color (white|brown|black)",
    },
    activeColor: {
      type: String,
      default: "actid",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
          "actid",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar active text color (primary|info|success|warning|danger)",
    },
    logo: {
      type: String,
      default: "/assets/actid/logo.png",
      description: "Sidebar Logo",
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  data() {
    return {
      balance: {
        real: "...",
        bonus: "...",
      },
      sidebarLinks: [],
      franchise: {
        logo: "",
      },
    };
  },
  methods: {
    async initScrollBarAsync() {
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },
    async refresh_balances() {
      return;
      console.log("this:", this.$anime, this.$refs.refresh_balances);
      this.$anime({
        targets: this.$refs.refresh_balances,
        rotateZ: [
          { value: 360, duration: 2000 },
          { value: 0, duration: 0, delay: 2000 },
        ],
      });
      var balances = await apiDriver.transactions.available();
      this.balance = balances;
    },
    async loadMenu() {
      let user = this.$store.state.userData.user;
      var subscriptions = this.$store.state.userData.subscriptions; //await apiDriver.subscriptions.list();
      var links = require("./sidebarLinks").default;
      this.franchise = this.$store.state.userData.franchise;

      var updatedLinks = [];
      for (var item of links) {
        if (!item.service_id) {
          if (!item.user_type && !item.only_for_users) {
            updatedLinks.push(item);
            continue;
          }
        }
        if (subscriptions.find((x) => x.service_id == item.service_id))
          updatedLinks.push(item);
        if (item.user_type) {
          if (item.user_type.includes(user.type)) updatedLinks.push(item);
        }
        if (item.only_for_users) {
          if (item.only_for_users.includes(user.id)) updatedLinks.push(item);
        }
      }

      this.sidebarLinks = updatedLinks;
    },
  },
  mounted() {
    this.initScrollBarAsync();
    // this.refresh_balances();
    this.loadMenu();
    setInterval(() => {
      this.loadMenu();
    }, 2000);
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

.sidebar {
  overflow: hidden;
}

.balances {
  position: relative;
  font-size: 10pt;
  left: 70px;
  margin-top: 5px;
}

.balances .refresh_balances {
  opacity: 0.6;
  cursor: pointer;
  margin-left: 10px;
}
.balances .refresh_balances:hover {
  opacity: 1;
}

.balances .balance {
  margin: -3px 0;
  cursor: default;
  display: inline-block;
}
.balances [type="real"]:after {
  content: "руб.";
  opacity: 0.5;
  margin-left: 4px;
}
.balances [type="bonus"]:after {
  content: "бон.";
  opacity: 0.5;
  margin-left: 4px;
}

.logo {
  background-size: auto 70% !important;
  background-position: 16px center !important;
  background-repeat: no-repeat !important;
  height: 56px;
}

.logout_button {
  color: black;
  opacity: 0;
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 18px;
  transition: 0.3s opacity;
}

.sidebar:hover .logout_button {
  opacity: 0.5;
}

.sidebar:hover .logout_button:hover {
  opacity: 1;
  cursor: pointer;
}

.sidebar .nav .collapse-menu .nav {
  border-left: 4px solid #dcdcdc;
}
</style>
